import React from 'react';
import { NavLink } from 'react-router-dom';
import { House, FilmSlate, Television, Broadcast, BookmarkSimple } from '@phosphor-icons/react';
import './BottomNav.css';

const ITEMS = [
    { to: '/', end: true, icon: House, label: 'Accueil' },
    { to: '/movies', icon: FilmSlate, label: 'Films' },
    { to: '/series', icon: Television, label: 'Séries' },
    { to: '/live', icon: Broadcast, label: 'Direct' },
    { to: '/mylist', icon: BookmarkSimple, label: 'Ma Liste' }
];

const BottomNav = ({ onPreloadRoute }) => {
    const intent = (path) => ({
        onMouseEnter: () => onPreloadRoute?.(path),
        onFocus: () => onPreloadRoute?.(path),
        onPointerDown: () => onPreloadRoute?.(path),
        onTouchStart: () => onPreloadRoute?.(path)
    });

    return (
        <nav className="bottom-nav" aria-label="Navigation principale">
            {ITEMS.map(({ to, end, icon, label }) => (
                <NavLink
                    key={to}
                    to={to}
                    end={end}
                    {...intent(to)}
                    aria-label={label}
                    title={label}
                    className={({ isActive }) => (isActive ? 'mnav-item active' : 'mnav-item')}
                >
                    {({ isActive }) => React.createElement(icon, { size: 26, weight: isActive ? 'fill' : 'regular' })}
                </NavLink>
            ))}
        </nav>
    );
};

export default BottomNav;
